import React from "react";
import "./DetailHero.css";

const DetailHero = () => {
  return (
    <section className="detail-hero">
      {/* Background */}
      <div
        className="detail-hero-background"
        style={{
          backgroundImage: "url('./detailsone.webp')",
        }}
      >
        <div className="detail-hero-overlay" />
      </div>

      <div className="detail-hero-content">
        {/* Header */}
        <div className="detail-hero-header">
          <h1 className="detail-hero-title">Building Connections That Matter</h1>
          <p className="detail-hero-subtitle">
            Discover how our humble networking group creates meaningful business
            relationships
          </p>
        </div>

        {/* Main Layout */}
        <div className="detail-hero-main">
          {/* Left Image (must match right column height) */}
          <div className="detail-hero-image">
            <div className="detail-image-wrapper">
              <img
                src="./details.webp"
                alt="Networking group meeting"
                className="detail-image"
              />
              <div className="detail-image-overlay" />

              <div className="detail-image-badge">
                <div className="badge-content">
                  <span className="badge-text">Weekly Meetups</span>
                  <span className="badge-subtext">Every Wednesday</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="detail-hero-text">
            <div className="text-content">
              <h2 className="text-title">Why Our Approach Works</h2>

              {/* ✅ 2 paragraphs, with a few more sentences (no em-dashes) */}
              <div className="paragraphs-container">
                <p>
                  At Businesses Grow Together, we believe authentic connections are the
                  foundation of strong business relationships. Our group brings together
                  professionals from diverse industries who share a common goal: to support
                  and uplift one another through real conversations and consistent community.
                  Each meetup is designed to make introductions easy and natural, even if you
                  are new to networking. You will leave with clear next steps and a team of professionals looking to refer out to you, not just
                  business cards.
                </p>

                <p>
                  Unlike traditional networking events, our meetups prioritize quality over
                  quantity. We foster a close-knit environment where every voice matters,
                  helping members build lasting partnerships, genuine referrals, and real
                  long-term growth. We also create space for learning through short member
                  spotlights and practical discussions. Over time, the relationships you build
                  here become a reliable support system for both business and mindset.
                </p>
              </div>
            </div>
          </div>
          {/* end right */}
        </div>
        {/* end main */}
      </div>
    </section>
  );
};

export default DetailHero;
